import { Delete, Edit } from "@mui/icons-material";
import { useState } from "react";
import { toast } from "react-toastify";
import { Button, TextInput } from "src/Components";
import { IDeltaHedgeExeStrategy } from "src/Interfaces/deltaHedgeExe";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import {
  addDeltaHedgeExeStrategies,
  deleteDeltaHedgeExeStrategies,
  editDeltaHedgeExeStrategies,
} from "src/Requests/deltaHedgeExe";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface Props {
  strategies: DropdownItem[];
  setRefreshStrategiesFlag: (flag: boolean) => void;
}

const StrategiesModal = ({ strategies, setRefreshStrategiesFlag }: Props) => {
  const [loading, setLoading] = useState(false);
  const [strategy, setStrategy] = useState<IDeltaHedgeExeStrategy>(
    {} as IDeltaHedgeExeStrategy
  );

  const handleDelete = (id: string) => {
    setLoading(true);
    deleteDeltaHedgeExeStrategies(id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          setRefreshStrategiesFlag(true);
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setLoading(false);
      });
  };

  const handleAddOrUpdate = () => {
    setLoading(true);
    (strategy?.id
      ? editDeltaHedgeExeStrategies(strategy)
      : addDeltaHedgeExeStrategies(strategy)
    )
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          setRefreshStrategiesFlag(true);
          setStrategy({} as IDeltaHedgeExeStrategy); // Reset strategy after adding/updating
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3">
      <div className="flex flex-col justify-start items-start gap-3 border-b border-gray-300 pb-3 w-full">
        {strategies.map((strategy, i) => (
          <div
            key={strategy.id}
            className="p-2 border rounded flex flex-row justify-between items-center gap-3 w-full"
          >
            <div>{i + 1}</div>
            <div>{strategy.name}</div>
            <Delete onClick={() => handleDelete(strategy.id?.toString())} />
            <Edit
              onClick={() =>
                setStrategy({
                  id: strategy.id?.toString(),
                  name: strategy.name,
                })
              }
            />
          </div>
        ))}
      </div>
      <div className="flex flex-row justify-start items-center gap-5 w-full">
        <TextInput
          label="استراتژی جدید"
          name=""
          onChange={(_, v) => setStrategy({ ...strategy, name: v })}
          value={strategy.name}
        />

        <Button
          variant="contained"
          onClick={handleAddOrUpdate}
          loading={loading}
          text={strategy?.id ? "ویرایش" : "افزودن"}
        />
      </div>
    </div>
  );
};

export default StrategiesModal;
